import TenantPage from 'layouts/TenantPage';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { loadingActions } from 'store';
import { useAppDispatch } from 'store/store';
import ContractHeaderForm from '../components/form/ContractHeaderForm';
import { useContractMutations } from '../hooks/mutations/useContractMutations';
import { useContractEditBootstrap } from '../hooks/queries/useContractEditBootstrap';
import { toAddContractPayload } from '../mappers/contracts.mappers';
import { ContractLine, IContract } from '../types';

const initContract: IContract = {
  code: null,
  active: true,
  laboratories: [],
  supplier: { id: null, code: null },
  drafting_date: null,
  expiration_date: null,
  id: 0,
  product: 0,
  unit_price: 0,
  units_per_year: 0,
  commercial_bid: false,
  bid_approval: false
};
export const AddContract = () => {
  const translationPrefix = 'pages.contract.new';
  const navigate = useNavigate();

  const [contractLines, setContractLines] = useState<ContractLine[]>([]);
  const { suppliers, laboratories } = useContractEditBootstrap();
  const { addContract } = useContractMutations();

  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const onSubmit = async (values) => {
    dispatch(loadingActions.startLoading());
    const payload = toAddContractPayload(values, contractLines);
    const res = await addContract(payload);
    if (res?.id) {
      enqueueSnackbar('Contratto aggiunto con successo', { variant: 'success' });
      navigate(`./../${res.id}`);
    }
    dispatch(loadingActions.stopLoading());
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <ContractHeaderForm
        contract={initContract}
        onSubmit={onSubmit}
        suppliers={suppliers}
        laboratories={laboratories}
      />
    </TenantPage>
  );
};

export default AddContract;
